module.exports = __webpack_public_path__ + "media/apps/shopper_download-a441d765.jpg";